var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"empty-box"},[_c('img',{staticClass:"icon-nodata",attrs:{"src":require("@/assets/img/empty.png")}}),_c('div',{staticClass:"empty-text"},[_vm._v(_vm._s(_vm.message)+"~")])])}
var staticRenderFns = []

export { render, staticRenderFns }